import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../../theme';

import { grey } from '@material-ui/core/colors';

import {Typography, Paper, IconButton} from '@material-ui/core';

import {ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LayersIcon from '@material-ui/icons/Layers';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { GeofencesListEditor } from './GeofencesListEditor';
import { getBase64ID, getIndexByID, getObjectByID } from '../../../../api/helpers';
import { EditGeofenceDialog } from './EditGeofenceDialog';
import { PersonPinCircle } from '@material-ui/icons';
import { KmlListEditor } from './KmlListEditor';
import { EditKmlLayerDialog } from './EditKmlLayerDialog';


class MapToolsPanel_ extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            panelsExpanded:{
                Geofences: true,
                KmlLayers: false
            },
            //geofences:[],
            geofenceDialog:{
                open: false,
                geofence: null,
                new: false
            },
            kmlLayerDialog:{
                open: false,
                kmlLayer: null,
                new: false
            },
            selectedGeofenceID: null,
            selectedKmlLayerID: null
        }

        ///this.props.onAction({type: 'GEOFENCES_GET', onComplete: this.onGeofencesGet.bind(this)})

        this.handleAction = this.handleAction.bind(this)

        this.handleGeofenceSelect = this.handleGeofenceSelect.bind(this)
        this.handleKmlLayerSelect = this.handleKmlLayerSelect.bind(this)

        this.geofenceContextMenu = this.geofenceContextMenu.bind(this)
        this.kmlListContextMenu = this.kmlListContextMenu.bind(this)

    }

    /*
    onGeofencesGet(result){
        //alert('onGeofenceGet')
        console.log('onGeofenceGet')
        console.log(result)

        this.setState({geofences: result})
    }
    */

    togglePanel(event, expanded, panel){

        this.setState(state => {
            state.panelsExpanded[panel] = expanded
            return state
        })

    }

    handleGeofenceAddClick(event){
        this.handleAction({type: 'GEOFENCE_DIALOG_ADD'})
        event.stopPropagation()
    }

    handleGeofenceSelect(id){
        this.setState({selectedGeofenceID: id})
    }

    handleKmlLayerSelect(id){
        this.setState({selectedKmlLayerID: id})
    }

    handleKmlLayerAddClick(event){
        this.handleAction({type: 'KML_LAYER_DIALOG_ADD'})
        event.stopPropagation()
    }

    handleAction(action){
        switch(action.type){

            case 'GEOFENCE_DIALOG_ADD':{
                //alert('GEOFENCE_ADD')

                this.setState({geofenceDialog: {open: true, geofence: null, new: true}})

                break;
            }

            case 'GEOFENCE_DIALOG_EDIT':{
                this.setState({geofenceDialog: {open: true, geofence: action.geofence}})

                break;
            }

            case 'GEOFENCE_DIALOG_SAVE':{
                //console.log('GEOFENCE_DIALOG_SAVE')
                //console.log({...action.geofence})

                this.props.onAction({type:'GEOFENCE_UPDATE', geofence: action.geofence})

                this.setState({geofenceDialog: {open: false, geofence: null}})
                break;
            }

            case 'GEOFENCE_DIALOG_CLOSE':{
                this.setState({geofenceDialog: {open: false, geofence: null}})
                break;
            }

            /*
            case 'GEOFENCE_SET_PROPERTY':{
                console.log('GEOFENCE_SET_PROPERTY')
                console.log(action)

                let geofence = getObjectByID(action.id, this.state.geofences) 
                geofence[action.name] = action.value

                let geofences = [...this.state.geofences]
                let index = getIndexByID(action.id, geofences)

                geofences[index] = geofence

                this.setState({geofences: geofences})

                this.props.onAction({type:'GEOFENCE_UPDATE', geofence: geofence})
                
                break;
            }
            */
            case 'KML_LAYER_DIALOG_ADD':{
                //alert('GEOFENCE_ADD')

                this.setState({kmlLayerDialog: {open: true, kmlLayer: null, new: true}})

                break;
            }

            case 'KML_LAYER_DIALOG_EDIT':{
                this.setState({kmlLayerDialog: {open: true, kmlLayer: action.kmlLayer}})

                break;
            }

            case 'KML_LAYER_DIALOG_SAVE':{
                //console.log('GEOFENCE_DIALOG_SAVE')
                //console.log({...action.geofence})

                this.props.onAction({type:'KML_LAYER_UPDATE', kmlLayer: action.kmlLayer})

                this.setState({kmlLayerDialog: {open: false, kmlLayer: null}})
                break;
            }

            case 'KML_LAYER_DIALOG_CLOSE':{
                this.setState({kmlLayerDialog: {open: false, kmlLayer: null}})
                break;
            }

            default:{
                //alert(action.type)
                return this.props.onAction(action)
            }
        }
    }

    geofenceContextMenu(menu, geofence){
        console.log('geofenceContextMenu '+menu)
        switch(menu){
            case 'DRAWONMAP':{

                break
            }

            case 'PROPERTIES':{
                console.log('geofence')
                console.log(geofence)
                this.setState({geofenceDialog: {open: true, geofence: geofence}})
                break
            }

            case 'DELETE':{
                //console.log('geofence')
                //console.log(geofence)
                this.props.onAction({type:'GEOFENCE_DELETE', geofence: geofence})
                break
            }
        }
    }

    kmlListContextMenu(menu, kmlLayer){
        console.log('kmlListContextMenu '+menu)
        switch(menu){
            case 'PROPERTIES':{
                console.log('kmlLayer')
                console.log(kmlLayer)
                this.setState({kmlLayerDialog: {open: true, kmlLayer: kmlLayer}})
                break
            }

            case 'DELETE':{
                //console.log('geofence')
                //console.log(geofence)
                this.props.onAction({type:'KML_LAYER_DELETE', kmlLayer: kmlLayer})
                break
            }
        }
    }

    render(){
        const {t} = this.props

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
              minHeight: 300
            },
            head: {
                //color: theme.palette.color.dialogTitle,
                //backgroundColor: theme.palette.background.dialogTitle,
                background: theme.palette.background.tabbedMenu,
                color: theme.palette.color.tabbedMenu,
                position: 'relative',
            },
            addIcon: {
                color: 'white',
                position: 'absolute',
                right: 50,
                top: 10
            },
            expandIcon: {
                color: 'white'
            }
        };

        return (
            <>

            {this.state.geofenceDialog.open?
                <EditGeofenceDialog {...this.state.geofenceDialog}
                    minWidth="md" fullWidth={true} onAction={this.handleAction}></EditGeofenceDialog>
            : null}

            {this.state.kmlLayerDialog.open?
                <EditKmlLayerDialog {...this.state.kmlLayerDialog}
                    minWidth="md" fullWidth={true} onAction={this.handleAction}></EditKmlLayerDialog>
            : null}


            <ExpansionPanel 
                expanded={this.state.panelsExpanded.Geofences} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, 'Geofences')}>
                <ExpansionPanelSummary style={styles.head} expandIcon={<ExpandMoreIcon style={styles.expandIcon} />}>
                    <PersonPinCircle style={{paddingRight:5}} />
                    
                    <Typography>{t('Geofences')}</Typography>

                    <IconButton size="small" color="primary" 
                        aria-label="more" component="span"
                        style={{...styles.addIcon, top:(this.state.panelsExpanded.Geofences?16:10)}}
                        onClick={(event)=>{this.handleGeofenceAddClick(event)}}>
                        <AddCircleOutlineIcon />
                    </IconButton>

                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', padding:0}}>
                    <GeofencesListEditor
                        geofences={this.props.geofences}
                        geofencePaintID={this.props.geofencePaintID} 
                        onAction={this.handleAction}
                        onContextMenu={this.geofenceContextMenu}
                        onSelect={this.handleGeofenceSelect}
                        selectedID={this.state.selectedGeofenceID}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>

            <ExpansionPanel 
                expanded={this.state.panelsExpanded.KmlLayers} 
                onChange={(event, expanded) => this.togglePanel(event, expanded, 'KmlLayers')}>
                <ExpansionPanelSummary style={styles.head} expandIcon={<ExpandMoreIcon style={styles.expandIcon} />}>
                    <LayersIcon style={{paddingRight:5}} />
                    
                    <Typography>{t('KmlLayers')}</Typography>

                    <IconButton size="small" color="primary" 
                        aria-label="more" component="span"
                        style={{...styles.addIcon, top:(this.state.panelsExpanded.KmlLayers?16:10)}}
                        onClick={(event)=>{this.handleKmlLayerAddClick(event)}}>
                        <AddCircleOutlineIcon />
                    </IconButton>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{display: 'block', padding:0}}>
                    <KmlListEditor 
                        kmlLayers={this.props.kmlLayers}
                        onAction={this.handleAction}
                        onContextMenu={this.kmlListContextMenu}
                        onSelect={this.handleKmlLayerSelect} 
                        selectedID={this.state.selectedKmlLayerID}
                        />
                </ExpansionPanelDetails>
            </ExpansionPanel>

            </>
        );

    }

}


export const MapToolsPanel = withTranslation()(MapToolsPanel_);